import * as yup from "yup";
export const approvalConfigrationSchema = yup.object().shape({
  payment_method_name: yup
    .string()
    .required("Payment Method Name is Required *"),

  program_coordinator_approvel: yup.boolean(),

  designated_approver: yup.array().when("program_coordinator_approvel", {
    is: true,
    then: yup.array().of(
      yup.object().shape({
        designated_approver_state: yup.string().required("State is Required *"),
        designated_approver_county: yup
          .string()
          .required("County is Required *"),
        designated_approver_email: yup
          .string()
          .email("Invalid email format")
          .required("Email is Required *"),
      }),
    ),
    otherwise: yup.array().of(
      yup.object().shape({
        designated_approver_state: yup.string().nullable(),
        designated_approver_county: yup.string().nullable(),
        designated_approver_email: yup.string().nullable(),
      }),
    ),
  }),

  cs_manager_approvel: yup.boolean(),

  executive_approvel_email: yup.string().when("executive_approvel_enable", {
    is: true,
    then: yup
      .string()
      .email("Invalid email")
      .required("Executive Approval Email is Required *"),
    otherwise: yup.string().nullable(),
  }),

  accounting_approvel_email: yup.string().when("accounting_approvel_enable", {
    is: true,
    then: yup
      .string()
      .email("Invalid email")
      .required("Accounting Email is Required *"),
    otherwise: yup.string().nullable(),
  }),
});

export const approvalConfigrationInitialValues = {
  status: "active",

  payment_method_name: "",
  program_coordinator_approvel: false,
  designated_approver: [
    {
      designated_approver_state: "",
      designated_approver_county: "",
      designated_approver_email: "",
    },
  ],
  cs_manager_approvel: false,
  executive_approvel_enable: false,
  accounting_approvel_enable: false,
  executive_approvel_email: "",
  accounting_approvel_email: "",
};
